import React from 'react'
import { useResolvers } from '../../../context'
import type { Overlay } from '@mission.io/mission-toolkit'
import Img from './LoadedImage'

type Props = { overlay: Overlay }

export default function ImageOverlay({ overlay }: Props): React$Node {
	const { imageSourceResolver } = useResolvers()
	return (
		<Img
			src={imageSourceResolver(overlay.url)}
			alt="overlay"
			hasBorder={true}
		/>
	)
}
